import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { StorageKeys } from 'src/app/core/models/enums/storage-keys';
import { AnalyticService } from 'src/app/core/services/analytic.service';
import { LoadingService } from 'src/app/core/services/loading.service';
import { ModalService } from 'src/app/core/services/modal.service';
import { NotificationService } from 'src/app/core/services/notification-service';
import { StorageService } from 'src/app/core/services/storage.service';
import { INotificationResponse } from '../../../models/notification';
import { ProfileService } from '../../services/profile.service';
import { NotificationDetailsComponent } from '../notification-details/notification-details.component';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
})
export class NotificationsComponent implements OnInit {
  list: Array<INotificationResponse> = [];
  allChecked: boolean = false;
  isChangeAvailable: boolean = true;

  constructor(private loadingService: LoadingService,
    private profileService: ProfileService,
    private modalService: ModalService,
    private storageService: StorageService,
    private analyticsService: AnalyticService,
    private notificationService: NotificationService,
    private translateService: TranslateService) { }

  ngOnInit() {
    this.getList();
  }

  ionViewDidEnter() {
    let pastChecked = this.allChecked;
    this.list = this.notificationService.notificationPermissionItemsList || [];
    if (this.list.filter(e => { return e.GroupPermission == true }).length == this.list.length) {
      this.allChecked = true;
    } else {
      this.allChecked = false;
    }
    if (pastChecked != this.allChecked) {
      this.isChangeAvailable = false;
    }
  }
  getList(isModal: boolean = false) {
    this.notificationService.GetNotificationPermissions().subscribe(e => {

      let pastChecked = this.allChecked;
      this.loadingService.hideLoading();

      this.notificationService.notificationPermissionItemsList = e.Data
      this.list = this.notificationService.notificationPermissionItemsList;

      this.list.forEach(e => {
        let a = e.ContainList.map(i => this.translateService.instant("notifications." + i.HeaderName)).join(", ");

        e.Description = a
      });
      if (this.list.filter(e => { return e.GroupPermission == true }).length == this.list.length) {
        this.allChecked = true;
      } else {
        this.allChecked = false;
      }
      if (pastChecked != this.allChecked) {
        this.isChangeAvailable = false;
      }
      setTimeout(() => {
        this.isChangeAvailable = true;
      }, 50);

    }, err => {
    });
  }
  openDetail(item: INotificationResponse) {
    let modalId = Date.now();
    this.modalService.presentModal({
      component: NotificationDetailsComponent,
      componentProps: {
        list: this.list,
        item: item
      },
      id: modalId,
      options: {}
    }).then(res => {
      res.modalObj.onDidDismiss().then(e => {
        if (e.role == "notification") {
          this.getList();
          let pastChecked = this.allChecked;
          this.list = this.notificationService.notificationPermissionItemsList || [];
          if (this.list.filter(e => { return e.GroupPermission == true }).length == this.list.length) {
            this.allChecked = true;
            
          } else {
            this.allChecked = false;
          }
          if (pastChecked != this.allChecked) {
            this.isChangeAvailable = false;
          }
          this.isChangeAvailable = false;
        }
      });
    });
  }
  change(ev) {
    if (this.isChangeAvailable) {
      if (ev) {
        let notifIdList = []
        this.list.forEach(e => {
          notifIdList.push(...e.ContainList.map(t => t.SlaveId));
        })
        let payload = {
          NotificationIds: notifIdList
        }
        this.loadingService.showLoading();
        this.profileService.saveNotificationPermission(payload).subscribe(res => {
          if (res.IsSuccess) {
            this.getList();
          }
          this.loadingService.hideLoading();
        });
      } else {
        let payload = {
          NotificationIds: [] as number[]
        };
        this.loadingService.showLoading();
        this.profileService.saveNotificationPermission(payload).subscribe(res => {
          if (res.IsSuccess) {
            this.getList();
          }
          this.loadingService.hideLoading();
        });
      }
    }
    this.isChangeAvailable = true;
  }
}
